module.exports = __webpack_public_path__ + "static/media/25.029eff50.mp4";